import { render, staticRenderFns } from "./question-list.vue?vue&type=template&id=61c57baa&scoped=true"
import script from "./question-list.vue?vue&type=script&lang=js"
export * from "./question-list.vue?vue&type=script&lang=js"
import style0 from "./question-list.vue?vue&type=style&index=0&id=61c57baa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c57baa",
  null
  
)

export default component.exports